import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, TrendingUpIcon, ActivityIcon, GraduationCapIcon } from 'lucide-react';
export function Expertise() {
  const expertiseAreas = [{
    title: 'Board Leadership & Governance',
    description: 'Deep expertise in corporate governance, strategic oversight, and risk management, advising executive leadership in highly regulated environments.',
    icon: <ShieldCheckIcon size={28} className="text-gold" data-id="element-131" />
  }, {
    title: 'Strategic Growth & Enterprise Value',
    description: 'Recognized for aligning clinical excellence with commercial performance, driving transformative outcomes and sustained, long-term value creation.',
    icon: <TrendingUpIcon size={28} className="text-gold" data-id="element-132" />
  }, {
    title: 'Clinical Innovation & Surgical Excellence',
    description: 'Pioneer in bone grafting and osseointegration, setting benchmarks in surgical innovation and advancing global standards of care.',
    icon: <ActivityIcon size={28} className="text-gold" data-id="element-133" />
  }, {
    title: 'Academic Leadership & Thought Leadership',
    description: 'Shaping the future of implantology through influential publications, executive education, and high-level advisory engagement globally.',
    icon: <GraduationCapIcon size={28} className="text-gold" data-id="element-134" />
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section id="expertise" className="py-24 md:py-32 bg-navy" data-id="element-135">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-136">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16 text-center flex flex-col items-center" data-id="element-137">
          <div className="w-16 h-px bg-gold mb-6" data-id="element-138"></div>
          <h2 className="font-sans text-gold text-sm uppercase tracking-widest font-medium mb-4" data-id="element-139">
            Areas of Expertise
          </h2>
          <h3 className="font-serif text-4xl md:text-5xl text-white font-medium leading-tight" data-id="element-140">
            Pillars of Leadership
          </h3>
        </motion.div>

        {/* Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-141">
          {expertiseAreas.map((area, index) => <motion.div key={index} variants={itemVariants} className="group bg-navy-rich p-10 border-t border-gold/40 hover:border-gold transition-all duration-300 hover:-translate-y-1 shadow-lg shadow-black/20" data-id="element-142">
              <div className="w-16 h-16 rounded-full border border-gold/30 flex items-center justify-center mb-8 group-hover:border-gold group-hover:bg-gold/5 transition-colors" data-id="element-143">
                {area.icon}
              </div>
              <h4 className="font-serif text-2xl text-white mb-4 group-hover:text-gold-bright transition-colors" data-id="element-144">
                {area.title}
              </h4>
              <p className="font-sans text-muted text-base leading-relaxed font-light" data-id="element-145">
                {area.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}